import { Stack } from '@mui/material';

import { HeaderCard } from '@/components/layout/HeaderCard';

import { GetUserProfileSettingsQuery } from '../graphql/UserProfileSettingsPage.generated';
import { AddeparCard } from './AddeparCard';
import { BlackDiamondCard } from './BlackDiamondCard';
import { EmoneyCard } from './EmoneyCard';
import { OrionCard } from './OrionCard';

interface IntegrationsCardProps {
  data: GetUserProfileSettingsQuery | undefined;
}

export function IntegrationsCard({ data }: IntegrationsCardProps) {
  return (
    <HeaderCard
      heading="Integrations"
      subheading="Enable data integrations by connecting Luminary to external services"
      sx={{ height: '100%' }}
    >
      <Stack spacing={2} mt={2} mb={2}>
        <AddeparCard
          userAccountLinked={data?.isUserLoggedInToAddepar.isLoggedIn ?? false}
          externalUserName={
            data?.isUserLoggedInToAddepar.externalUserName ?? null
          }
          integrationConfigured={Boolean(
            data?.integrationConfiguration?.addeparFirmID ?? false
          )}
        />
        <BlackDiamondCard
          userAccountLinked={
            data?.isUserLoggedInToBlackDiamond.isLoggedIn ?? false
          }
          externalUserName={
            data?.isUserLoggedInToBlackDiamond.externalUserName ?? null
          }
        />
        <OrionCard
          userAccountLinked={data?.isUserLoggedInToOrion?.isLoggedIn ?? false}
          externalUserName={
            data?.isUserLoggedInToOrion?.externalUserName ?? null
          }
        />
        <EmoneyCard
          userAccountLinked={data?.isUserLoggedInToEMoney?.isLoggedIn ?? false}
          externalUserName={
            data?.isUserLoggedInToEMoney?.externalUserName ?? null
          }
          integrationConfigured={Boolean(
            data?.integrationConfiguration?.emoneyEnabled ?? false
          )}
        />
      </Stack>
    </HeaderCard>
  );
}
